import styled from 'styled-components';
import StyledButton from 'components/UI/Button/StyledButton';
import { Color } from 'modules/styles/colors';
import background from 'assets/backgrounds/background.png';
import Box from 'components/UI/Layout/Box';
import { MuiButton } from 'theme/material-ui';

export const OnBoardingButton = styled(StyledButton)`
  border: ${Color.foreColor};
  width: 100%;
`;

// Display logic for block or flex due to an issue with safari on mobile
export const LandingImageBackground = styled(Box)<{ isSmallScreen: boolean }>`
  display: ${props => (props.isSmallScreen ? 'block' : 'flex')};
  flex: 1;
  background: url(${background});
  background-repeat: no-repeat;
  background-size: 100% 100%;
`;

const largeLogoWidth = 510;
const smallLogoWidth = 300;
const logoAspectRatio = 3.4;

export const Logo = styled.img<{ isSmallScreen: boolean }>`
  width: ${props => (props.isSmallScreen ? `${smallLogoWidth}px` : `${largeLogoWidth}px`)};
  height: ${props =>
    props.isSmallScreen
      ? `${smallLogoWidth / logoAspectRatio}px`
      : `${largeLogoWidth / logoAspectRatio}px`};
`;

export const LandingButton = styled(MuiButton)`
  .MuiButton-label {
    font-size: 14px;
  }
`;
